import React, { useEffect, useState } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import PermissionGate from '../../../../helpers/PermissionGate';
import { useUcs } from '../../../../helpers/contexts/UserCompanySettingsContext';
import Link from '@mui/material/Link'
import checkFlag from '../../../../helpers/featureFlags';
import { Typography , Stack} from '@mui/material';

function BankingEnabledValue(props) {
	const [bankingEnabled, setBankingEnabled] = useState('');
  const [isDashboardEditor, setIsDashboardEditor] = useState(false)
  const [linkText, setLinkText] = useState('')
  
  const ucsContext = useUcs()

  useEffect(() => {
    if (ucsContext.loaded) {
      if (!checkFlag('dashboardEditor')) {
        setIsDashboardEditor(true)
      } else {
        setIsDashboardEditor(ucsContext.isDashboardEditor())
      }
    }
  }, [ucsContext])

	useEffect(() => {
    const linkColor = isDashboardEditor ? null : 'grey'
		if (props.isBankingEnabled) {
			setBankingEnabled("Yes")
      setLinkText('')
		}

		else if (props.isInProgress) {
			setBankingEnabled('In Progress')
			if( props.newEntityURL && props.newEntityURL.length > 0) {
        setLinkText('View Application')
			} else {
				setLinkText('')
			}
		}

		else if (props.newEntityURL && props.newEntityURL.length > 0) {
			setBankingEnabled('No')
      setLinkText('Start Application')
		}

	}, [props.isComplete, props.isInProgress, props.newEntityURL, props.editEntityURL]);

  return (
    <Stack direction='row' spacing={0.5}>
      <Typography variant='primary'>{bankingEnabled}</Typography>
      <PermissionGate
        requiredRole='dashboardEditor'
        toolTipText='Only admins and dashboard editors may access the entity bank enabling process'
        readOnly={
          <Link component='button' disabled sx={{ color: 'grey' }} underline='none'>
            {linkText}
            <ArrowRightOutlined style={{ marginLeft: '3px' }} />
          </Link>
        }
      >
        <Link href={props.newEntityURL} underline='none' rel='noopener noreferrer' target="_blank">
          {linkText}
          <ArrowRightOutlined style={{ marginLeft: '3px' }} />
        </Link>
      </PermissionGate>
    </Stack>
  )
}

export default BankingEnabledValue
